<template>
	<fragment>
		<common-header
			subname="설문 관리"
			name="설문 관리"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu></common-side-menu>
			<!-- //end .side-nav -->
			<div class="container-fiuld clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">설문 관리</div>
					<!--
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					-->
				</div>
				<div class="new-survey" v-if="!list || list.length==0">
					<img src="images/survey.png" alt=""><br>
					편집 할 설문을 선택하거나 새 설문을 만들 수 있습니다.<br>
					<a @click="createSurvey">새 설문 만들기</a>
				</div>

				<div class="white-box m-t-10 clearfix" v-for="(survey,idx) in list" :item="survey" :index="idx" :key="'survey-list-'+curriculumId+'-'+idx+'-'+hash(survey)">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">설문 {{idx+1}} : {{survey.surveyName}} ({{survey.surveyItemMappingList.length}}문항)</p>
							<p class="f-14 m-b-0">응시기간 : {{survey.surveyStart | parseRegDate}} ~ {{survey.surveyEnd | parseRegDate}}</p>
						</span>
						<span class="input-group-addon v-mid w400">
							<button class="btn round" @click="$router.push('/surveys/modify/'+survey.surveyId)">설문문항 편집</button>&nbsp;
							<button class="btn round" @click="createLink(survey.surveyId)">링크 (복사)</button>&nbsp;
							<!-- <button class="btn round" @click="sendLink(survey.surveyId)">링크 (문자로 전송)</button>&nbsp; -->
							<!--
							<button class="btn round">응답 검토</button>
							-->
						</span>
						<span class="input-group-addon v-mid w60">
							<a class="del" @click="deleteSurvey(survey)">삭제</a>
						</span>
					</div>
				</div>
			</div>
		</section>

		<modal-sms :config="modals.ModalSms" @close="modals.ModalSms.show=false;" :key="hash(modals.ModalSms)"></modal-sms>
		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import ModalSms from '../modals/ModalSms.vue'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomSurveyList',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
		ModalSms
	},

	mounted: function() {
		this.refresh();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus: [ // 서브메뉴
				{name:'설문 관리',link:"/surveys",selected:true},
				{name:'설문문항 관리',link:"/surveyItems",selected:false},
				{name:'설문 분류',link:"/surveys/categories",selected:false},
				{name:'설문 통계',link:"/surveys/statistics",selected:false},
			],
			buttons : [
				{name:'새 설문 만들기', fn:this.createSurvey}
			],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
				ModalSms: ModalSms.default()
			},
			curriculumId: this.$route.params.curriculumId,
			list: []
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		// 설문지를 만든다.
		createSurvey: function() {
			this.$router.push('/surveys/register/');
		},
		// 설문 목록을 불러온다.
		refresh: function() {
			axios.post(server.addr()+server.api.SURVEY, {}).then( (response) => {
				this.list = response.data.list;
			});
		},
		deleteSurvey: function(survey) {
			this.modals.ModalConfirm.msg = "설문지를 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				axios.delete(server.addr()+server.api.SURVEY+"/"+survey.surveyId).then( () => {
					this.refresh();
					this.modals.ModalConfirm.show = false;
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		createLink: function(surveyId) {
			this.modals.ModalAlert.msg = `인터넷 주소를 복사하세요.<br><br>${location.origin}/${server.hostParentName}/survey.html?state=1&surveyId=${surveyId}`;
			this.modals.ModalAlert.show = true;
		},
	},

	filters: {
		parseRegDate(date){
			return moment(date).format('YYYY-MM-DD')
		},
	}
}
</script>
